import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { deleteBoardUser } from '../requests';
import type { DeleteBoardUserRequest } from '../types';

export const useDeleteBoardUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: DeleteBoardUserRequest) => deleteBoardUser(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_QUERY_KEYS.boardUsers],
      });
    },
  });
};
